module.exports = __webpack_public_path__ + "img/sxsjs3.11a7d9fc.png";